/* eslint-disable import/no-unresolved */
import {
  BgColorsOutlined,
  DeleteOutlined,
  ExpandOutlined,
  GiftOutlined,
  GroupOutlined,
  LeftOutlined,
  RightOutlined,
  TrophyOutlined,
} from '@ant-design/icons';
import { Button, Checkbox, Col, Input, Row, Select, Tooltip } from 'antd';
import Monetary from 'components/UI/Data/Monetary';
import ImageGallery from 'components/UI/NewImageGallery';
import Quality from 'components/UI/Quality';
import { offerTypeMap } from 'enums/offerTypeMap';
import { PackingTypeEnum } from 'enums/packingType';
import { PackingTypeSale } from 'enums/packingTypeSale';
import { useShippingFee } from 'hooks/useShippingFee';
import Packing from 'model/Packing';
import ProductOffer from 'model/ProductOffer';
import { PostBodyProductInCart } from 'model/types';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import InfoObservation from 'screens/Products/components/ProductItem/components/InfoObservation';
import { cartSelectors, sessionSelectors } from 'store/state/selectors';
import { calculateMinBySaleType } from 'utils/util';
import imageComum from '../../../../assets/default/image.png';
import {
  formatDecimal,
  formatFullDecimal,
  numberUtils,
} from '../../../../utils/number';
import OfferTypeBadge from '../OfferTypeBadge';
import * as S from './styles';

type ProductOfferProps = {
  className?: string;
  productOffer: ProductOffer;
  setSelectedsProducts: React.Dispatch<
    React.SetStateAction<PostBodyProductInCart[]>
  >;
  selectedsProducts?: PostBodyProductInCart[];
  step?: string;
  returnFistStep: React.Dispatch<React.SetStateAction<number>>;
};

const { Option } = Select;

export default function ProductCardListComposition({
  className,
  setSelectedsProducts,
  selectedsProducts,
  productOffer,
  step,
  returnFistStep,
}: ProductOfferProps) {
  const {
    offerId,
    offerType,
    defaultImage,
    images,
    barcode,
    gtincode,
    quality,
    colors,
    productColorId,
    productQualityId,
    producerId,
    dimension,
    siteId,
    productId,
    packingCost,
    packings,
    layerPrice,
    packagingPrice,
    trolleyPrice,
    startDate,
    endDate,
    observation,
    siteDeliveryPatterns,
    longName,
    conceptName,
    shippingFeeFilials,
  } = productOffer;

  const selectedCustomerId = useSelector(
    sessionSelectors.getSelectedCustomerId,
  );
  const { customers } = useSelector(sessionSelectors.getRoot);

  const [arrayImage, setArrayImage] = useState<string[]>([]);
  const [imageDisplay, setImageDisplay] = useState<number>(0);
  const [selectedPackingId, setSelectedPacking] = useState<Packing>(
    (): Packing =>
      packings.find((packing) => packing.type === PackingTypeEnum.RETORNAVEL) ??
      packings.find((packing) => packing.code === '800') ??
      packings[0],
  );
  const cartId = useSelector(cartSelectors.getVolOfferId);
  const billingDate = useSelector(sessionSelectors.getSelectedBillingDate);
  const deliveryDate = useSelector(sessionSelectors.getSelectedDeliveryDate);
  const isAuthenticated = useSelector(sessionSelectors.getAuthenticated);

  const [quantityPacking, setQuantityPacking] = useState(0);

  const { shippingFee, hasShippingFee } = useShippingFee(productOffer);

  const handleImageDisplay = (value: number) => {
    if (value < 0) {
      setImageDisplay(arrayImage.length - 1);
    } else if (value >= arrayImage.length) {
      setImageDisplay(0);
    } else {
      setImageDisplay(value);
    }
  };

  const handleQuantityPacking = (quantity: number) => {
    setSelectedsProducts((oldValue) =>
      oldValue.map((product) => {
        if (product.volOfferId === offerId || product.lkpOfferId === offerId) {
          return {
            ...product,
            quantity,
          };
        }
        return {
          ...product,
        };
      }),
    );
  };

  const handlePackingId = () => {
    let arrayAux: PostBodyProductInCart[] = [];

    selectedsProducts?.forEach((product) => arrayAux.push(product));

    if (
      !arrayAux.find(
        (product) =>
          product.volOfferId === offerId || product.lkpOfferId === offerId,
      )
    ) {
      handleSelectOrRemoveProduct(offerId);
    }

    const productEdit = arrayAux.find(
      (product) =>
        product.volOfferId === offerId || product.lkpOfferId === offerId,
    );

    arrayAux = arrayAux.filter(
      (product) =>
        product.volOfferId !== offerId && product.lkpOfferId !== offerId,
    );

    if (productEdit) {
      arrayAux.push(productEdit);
    }

    setSelectedsProducts(arrayAux);
  };

  const isLkpOffer = useMemo(() => offerType === 1 || offerType === 2, [offerType]);

  const handleSelectOrRemoveProduct = (productIdValue: number) => {
    let arrayAux: PostBodyProductInCart[] = [];
    selectedsProducts?.forEach((product) => arrayAux.push(product));

    if (
      arrayAux.find(
        (product) =>
          product.volOfferId === productIdValue ||
          product.lkpOfferId === productIdValue,
      )
    ) {
      arrayAux = arrayAux.filter(
        (product) =>
          product.volOfferId !== productIdValue &&
          product.lkpOfferId !== productIdValue,
      );
    } else {
      arrayAux.push({
        cartId,
        packingId: selectedPackingId.id,
        maxAvailablePackingsQuantity:
          selectedPackingId.maxAvailablePackingsQuantity,
        volOfferId: !isLkpOffer ? offerId : null,
        lkpOfferId: isLkpOffer ? offerId : null,
        volumeType: 'Packing',
        offerType: offerTypeMap[offerType],
        quantity: 0,
        productColorId,
        productId,
        siteId,
        productQualityId,
        producerId,
        billingDate,
        deliveryDate,
      });
    }
    setSelectedsProducts(arrayAux);

    if (step === 'second-step' && (!arrayAux || arrayAux?.length <= 0)) {
      returnFistStep(0);
    }
  };

  const handleValuePackingSelected = (value: number) => {
    if (value) {
      setSelectedPacking(packings.find((packing) => packing.id === value)!);
      handlePackingId();
    }
  };

  const validQuantity = (event: any) => {
    const newQuantity = event.target.value + parseInt(event.key, 10);

    if (newQuantity > selectedPackingId.maxAvailablePackingsQuantity) {
      return event.preventDefault();
    }
    return numberUtils.onlyNumber(event);
  };

  useEffect(() => {
    if (images && images.length > 0) {
      setArrayImage(images);
    } else {
      setArrayImage([defaultImage || imageComum]);
    }
  }, [images]);

  const handleShippingFee = useCallback(() => {
    const customer = customers.find(c => c.id === selectedCustomerId);

    if(customer?.branch === "CVH_UB"){
      return (
        <Row justify='end'>
          <S.ShippingFeeValue>Valor frete: <b>{
            Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL', maximumFractionDigits: 6})
                .format(shippingFeeFilials[0].productShippingValue)
          }
          </b>
          </S.ShippingFeeValue>
        </Row>
      )
    }

    return null;
  }, [customers, selectedCustomerId, shippingFeeFilials])

  return (
    <S.ProductCardListComponent className={className}>
      {step === 'first-step' && (
        <S.ProductCardCheck md={1} lg={1} xl={1}>
          <Checkbox
            checked={
              !!selectedsProducts?.find(
                (product) =>
                  product.volOfferId === offerId ||
                  product.lkpOfferId === offerId,
              )
            }
            onChange={() => handleSelectOrRemoveProduct(offerId)}
          />
        </S.ProductCardCheck>
      )}
      <S.ProductCardComponentImage span={2}>
        <div>
          <Button
            type="text"
            onClick={() => handleImageDisplay(imageDisplay - 1)}
            icon={<LeftOutlined />}
            className='arrow-button'
          />
          <ImageGallery
            images={arrayImage}
            currentImage={arrayImage[imageDisplay]}
            maxHeight="150px"
          />
          <Button
            type="text"
            onClick={() => handleImageDisplay(imageDisplay + 1)}
            icon={<RightOutlined />}
            className='arrow-button'
          />
        </div>
        <span className='image-info'>
          Imagem{' '}
          {images.length > 0 && !isLkpOffer ? 'do produtor' : 'ilustrativa'}
        </span>
      </S.ProductCardComponentImage>

      <S.ProductCardComponentDetails span={14}>
        <Row className="row-details-name">
          <Col className="col-details" xs={24}> 
            <S.ProductNameType>
              <div className="name-product">
                <Tooltip title={longName}>
                  <span>{longName}</span>
                </Tooltip>
                {conceptName && (
                  <Tooltip title={conceptName}>
                    <span className="concept-name">{conceptName}</span>
                  </Tooltip>
                )}
              </div>
              <div className="code-product">
                <span className="number-product">{barcode}</span>
                <span>{gtincode}</span>
              </div>
              <div className="remove-display-calendar">
                <OfferTypeBadge
                  siteDeliveryPatterns={siteDeliveryPatterns}
                  offerType={offerType}
                  startDate={startDate}
                  endDate={endDate}
                />
              </div>
            </S.ProductNameType>
          </Col>
        </Row>
        <Row className="row-details" align="top" gutter={16}>
              <Col span={4}>
              <S.ProductInfo>
                <TrophyOutlined className="icon" />
                  <div className="group-information">
                    <p className="title">Qualidade:</p>
                    <Quality quality={quality} />
                  </div>
              </S.ProductInfo>
              </Col>
              <Col span={4}>
                <S.ProductInfo>
                  <ExpandOutlined className="icon" />
                  <div className="group-information">
                    <p className="title">Dimensão/Altura:</p>
                    <span>{dimension}</span>
                  </div>
                </S.ProductInfo>
              </Col>
              <Col span={3}>
              <S.ProductInfo>
                  <BgColorsOutlined className="icon" />
                  <div className="group-information">
                    <p className="title">Cores:</p>
                    <span>{colors}</span>
                  </div>
                </S.ProductInfo>
              </Col>
              <Col span={3}>
                <S.ProductInfo>
                  <GroupOutlined className="icon" />
                  <div className="group-information">
                    <p className="title">Múltiplo:</p>
                    <span>{selectedPackingId?.multiple}</span>
                  </div>
                </S.ProductInfo>
              </Col>
              <Col span={4} className="product-info-packing">
                <S.ProductInfo>
                  <GiftOutlined className="icon" />
                  <div className="group-information">
                    <p className="title">Embalagem:</p>
                    {packings && packings.length > 0 ? (
                      <Select
                        onChange={(value) => handleValuePackingSelected(value)}
                        value={selectedPackingId.id}
                        style={{ display: 'flex' }}
                        bordered={false}
                        className='package-select'
                        dropdownMatchSelectWidth={false}
                      >
                        {packings &&
                          packings.map((packing: Packing) => (
                            <Option
                              value={packing.id}
                              key={`${offerId}-${packing.id}`}
                            >
                              {packing.code} - {packing.description}
                            </Option>
                          ))}
                      </Select>
                    ) : null}
                  </div>
                </S.ProductInfo>
              </Col>
          <Col className="col-details-color" span={5}>
            <p>
              Observação:
              <InfoObservation observation={observation}/>
            </p>
          </Col>
        </Row>
      </S.ProductCardComponentDetails>

      <S.ProductCardComponentActions span={7}>
        {handleShippingFee()}
        {isAuthenticated && (
          <S.CheckboxContainer>
            <S.CheckBoxButton isDisabled={false}>
              <S.CompositionRadio value="Packing" checked />
              <S.SaleTypePriceContainer>
                Embalagem
                <S.SaleTypePrice checked>
                  <Monetary
                    symbol
                    value={
                      selectedPackingId?.additionalCost
                        ? packingCost + packagingPrice
                        : packagingPrice
                    }
                  />
                </S.SaleTypePrice>
              </S.SaleTypePriceContainer>
            </S.CheckBoxButton>
            <S.SaleTypeDivider />
            <S.CheckBoxButton isDisabled>
              <S.CompositionRadio value="Layer" checked={false} disabled />
              <S.SaleTypePriceContainer>
                Camada
                <S.SaleTypePrice checked={false}>
                  <Monetary
                    symbol
                    value={
                      selectedPackingId?.additionalCost
                        ? packingCost + layerPrice
                        : layerPrice
                    }
                  />
                </S.SaleTypePrice>
              </S.SaleTypePriceContainer>
            </S.CheckBoxButton>
            <S.SaleTypeDivider />
            <S.CheckBoxButton isDisabled>
              <S.CompositionRadio value="Trolley" checked={false} disabled />
              <S.SaleTypePriceContainer>
                Carrinho
                <S.SaleTypePrice checked={false}>
                  <Monetary
                    symbol
                    value={
                      selectedPackingId?.additionalCost
                        ? packingCost + trolleyPrice
                        : trolleyPrice
                    }
                  />
                </S.SaleTypePrice>
              </S.SaleTypePriceContainer>
            </S.CheckBoxButton>
          </S.CheckboxContainer>
        )}
          <S.AvailableQuantity />
        {step === 'second-step' && (
          <Input
            className="input-quantity"
            onKeyDown={(event) => validQuantity(event)}
              onChange={(event) => {
                const value = +event.target.value;
                setQuantityPacking(value);
                handleQuantityPacking(value);
              }}
            addonAfter="Embalagens"
            style={{ marginTop: '8px' }}
          />
        )}
        <S.InfoFirstRow>
          <S.MinQuantityProduct>
            Compra mínima: {calculateMinBySaleType(PackingTypeSale.Packing, selectedPackingId)} Embalagem(ns)
          </S.MinQuantityProduct>
          <span>Total disponível: {selectedPackingId.maxAvailablePackingsQuantity}</span>
          {hasShippingFee && (
            <S.ShippingFeeInline>Frete: R$ {formatFullDecimal(shippingFee)}</S.ShippingFeeInline>
          )}
        </S.InfoFirstRow>
        {selectedPackingId.unitsPerPackage > 0 && (
          <div style={{ fontSize: '12px', color: '#595959', marginTop: '2px' }}>
            Unidades por embalagem: {selectedPackingId.unitsPerPackage} unidade{selectedPackingId.unitsPerPackage !== 1 ? 's' : ''}
          </div>
        )}
        {quantityPacking > 0 && (
          <div style={{ fontSize: '12px', color: '#262626', fontWeight: 600, marginTop: '2px' }}>
            Total do pedido: {quantityPacking} Embalagem{quantityPacking !== 1 ? 'ns' : ''} × {selectedPackingId.unitsPerPackage} = {quantityPacking * selectedPackingId.unitsPerPackage} un.
          </div>
        )}
      </S.ProductCardComponentActions>
      
      {step === 'second-step' && (
        <S.ProductCardButtonDelete md={1} lg={1} xl={1}>
          <Button
            icon={<DeleteOutlined />}
            onClick={() => handleSelectOrRemoveProduct(offerId)}
          />
        </S.ProductCardButtonDelete>
      )}

    </S.ProductCardListComponent>
  );
}
